//#region src/enums/pagination-enums.ts
var e = /* @__PURE__ */ function(e) {
	return e.Next = "next", e.Prev = "prev", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.Asc = "ASC", e.Desc = "DESC", e;
}({});
//#endregion
export { e as PaginationOrderEnum, t as SortDirectionEnum };
